import graphql from '../utils/graphql';
export default {
  async getTipoArchivos({ commit, getters }) {
    if (!getters.getTipoArchivos.length) {
      try {
        const query = {
          query: ` query {
            tipos: getTipoArchivos {
              codigo
              nombre
            }
          }
          `,
        };
      const { tipos } = await graphql.request(query);
      commit('setTipoArchivos', tipos);
      } catch (err) {
        commit('error-notification', err.message);
      }
    }
  },

};
